import { Avatar, Box, CircularProgress, Grid, Typography } from "@mui/material";
import {
  ActivityQueryFiltersDtoTypeEnum,
  GetTicketChangeLogDTOActionEnum,
  TicketDto,
} from "../../../api-client";
import { useFetchTicketActivities, useAddComment } from "../../../stores/Ticketing";
import { Timeline, TimelineEvent } from "react-event-timeline";
import InfiniteScroll from "react-infinite-scroll-component";
import React, { useState } from "react";
import { format } from "date-fns";
import { MobiliAvatar } from "../../../atoms/MobiliAvatar";
import CommentInput from "./CommentInput";

const TicketHistoryTimeline: React.FC<{ selectedTicket: TicketDto; setTicketData: any }> = ({
  selectedTicket,
  setTicketData,
}) => {
  const [newCommentText, setNewCommentText] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const addComment = useAddComment();

  // Handle comment submission
  const handleSubmit = async () => {
    try {
      if (!selectedTicket.id || !newCommentText.trim()) return;
      
      const response = await addComment.mutateAsync({
        ticketId: selectedTicket.id,
        commentData: { comment: newCommentText },
      });
      
      if (response) {
        setNewCommentText("");
      }
    } catch (error) {
      console.error("Error submitting comment:", error);
    }
  };

  const handleEmojiSelect = (emoji: any) => {
    if (emoji && emoji.emoji) {
      setNewCommentText((prevText) => prevText + emoji.emoji);
    }
    setShowEmojiPicker(false);
  };

  const {
    data: allHistoryActivities,
    isFetching,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useFetchTicketActivities({
    limit: 10, // Increased from 3 to 10 to match other components
    type: [ActivityQueryFiltersDtoTypeEnum.History],
    ticketId: selectedTicket.id,
  });

  const fetchedAllActivitiesCount =
    allHistoryActivities?.pages.reduce((total, page) => total + page.length, 0) || 0;

  return (
    <Box sx={{ 
      height: '500px', 
      width: '100%',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Scrollable History Area */}
      <Box
        id="scrollableHistoryActivityDiv"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: '90px', // Reserve exactly 90px for input
          overflowY: "auto",
          overflowX: "hidden",
          paddingBottom: 1,
        }}
      >
      <Timeline>
        <InfiniteScroll
          dataLength={fetchedAllActivitiesCount}
          next={() => {
            fetchNextPage();
          }}
          hasMore={!!hasNextPage}
          loader={
            <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
              <CircularProgress size={24} color="inherit" />
            </Box>
          }
          scrollableTarget="scrollableHistoryActivityDiv"
        >
          {selectedTicket.id &&
            allHistoryActivities?.pages.map((page, index: any) =>
              page.map((activity) => (
                <React.Fragment key={activity.id}>
                  {/* {activity.text && activity.type !== "COMMENTS" && activity.text && (


                )} */}
                  <TimelineEvent
                    //key={`${index}-${textIndex}`}
                    title={`${activity?.text?.changeMessage} ${
                      activity.text.action?.toLowerCase() ===
                      GetTicketChangeLogDTOActionEnum.Created?.toLowerCase()
                        ? `${activity.text.action} ${activity.text.current}`
                        : `${activity.text.action} ${activity.text.field}`
                    }`}
                    createdAt={
                      <div style={{ textAlign: "right" }}>
                        {activity?.text?.createdAt &&
                          format(new Date(activity?.text?.createdAt), "dd.MM.yyyy, HH:mm")}
                      </div>
                    }
                    icon={
                      activity.text?.updatedByUser && (
                        <MobiliAvatar
                          user={activity.text?.updatedByUser}
                          sx={{ width: 32, height: 32, fontSize: "0.8rem" }}
                        />
                      )
                    }
                  >
                    {activity.text.action?.toLowerCase() !==
                      GetTicketChangeLogDTOActionEnum.Created.toLowerCase() && (
                      <Typography variant="body2" gutterBottom>
                        {`${activity.text.previous} - ${activity.text.current}`}
                      </Typography>
                    )}
                  </TimelineEvent>
                </React.Fragment>
              ))
            )}
        </InfiniteScroll>
      </Timeline>
      </Box>

      <CommentInput
        newCommentText={newCommentText}
        setNewCommentText={setNewCommentText}
        onSubmit={handleSubmit}
        showEmojiPicker={showEmojiPicker}
        setShowEmojiPicker={setShowEmojiPicker}
        onEmojiSelect={handleEmojiSelect}
      />
    </Box>
  );
};

export default TicketHistoryTimeline;
